// src/routes/RoleRoute.tsx
import React, { useEffect, useState, ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import { getUserRole } from "../utils/authUtils";

interface RoleRouteProps {
  children: ReactElement;
  allowedRoles: string[];
}

const RoleRoute: React.FC<RoleRouteProps> = ({ children, allowedRoles }) => {
  const [authorized, setAuthorized] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user: User | null) => {
      if (!user || !user.email) {
        setAuthorized(false);
        setLoading(false);
        return;
      }

      const role = await getUserRole(user.email);
      if (role && allowedRoles.includes(role)) {
        setAuthorized(true);
      } else {
        setAuthorized(false);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, [allowedRoles]);

  if (loading) return <p>Chargement...</p>;
  if (!authorized) return <Navigate to="/unauthorized" />;

  return children;
};

export default RoleRoute;
